module.exports = __webpack_public_path__ + "static/media/scary_slots.4e2bd419.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/scary_slots.png
// module id = 329
// module chunks = 0